import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/src/app/(main)/layout.tsx");
